import http from "../http-common";

class SettingsService {
    getPublicSettings() {
        return http.get("settings/public");
    }
}

export default new SettingsService();